import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    initialize() {
        super.initialize();
        this.typeTimer = null;
    }

    clear() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete('_global_search');
        urlSearchParams.delete('page');
        Turbo.visit(location.pathname + '?' + urlSearchParams);
    }

    updateQuery(event) {
        clearTimeout(this.typeTimer);

        this.typeTimer = setTimeout(() => {
            const search = event.target.value;
            const urlSearchParams = new URLSearchParams(window.location.search);

            if (search) {
                urlSearchParams.set('_global_search', search);
            } else {
                urlSearchParams.delete('_global_search');
            }

            urlSearchParams.delete('page');

            Turbo.visit(location.pathname + '?' + urlSearchParams);
        }, 500);
    }
}
